import { render, staticRenderFns } from "./SelfPageFollower.vue?vue&type=template&id=70041415&scoped=true&"
import script from "./SelfPageFollower.vue?vue&type=script&lang=js&"
export * from "./SelfPageFollower.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=70041415&lang=css&scoped=true&"
import style1 from "./SelfPageFollower.vue?vue&type=style&index=1&id=70041415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70041415",
  null
  
)

export default component.exports